<template>
  <div class="flex">
    <div class="flex relative">
      <div class="flex">
        <img
          v-for="(star, i) in 5"
          :key="i"
          src="/_nuxt3-static/events/star.svg"
          alt="Star"
          class="grayscale brightness-125"
          :class="starClasses"
        />
      </div>

      <div
        class="flex absolute overflow-hidden"
        :style="{ width: `${(averageRating / 5) * 100}%` }"
      >
        <img
          v-for="(star, i) in 5"
          :key="i"
          src="/_nuxt3-static/events/star.svg"
          alt="Star"
          :class="starClasses"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { averageRating = 0, starClasses = 'h-3.5 md:h-4' } = defineProps<{
  averageRating: number
  starClasses: string
}>()
</script>
